export default {
    install: function (Vue, options) {
        Vue.prototype.toast = {
            /**
             * Toast success
             */
            success: () => {
                Vue.toasted.success(options.i18n.t('common.toast.save.ok'), {
                    action: [
                        {
                            text: options.i18n.t('common.close'),
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        }
                    ]
                }).goAway(2000);
            },
            /**
             * Toast info
             * @param message
             */
            info: (message) => {
                Vue.toasted.info(message, {
                    action: [
                        {
                            text: options.i18n.t('common.close'),
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        }
                    ]
                }).goAway(2000);
            },
            /**
             * Toast di errore
             * @param message
             */
            error: (message) => {
                Vue.toasted.error(message, {
                    action: [
                        {
                            text: options.i18n.t('common.close'),
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        }
                    ]
                }).goAway(3000);
            }
        }
    },

}
